import DapDSSearch from './search.component'

export * from './search.component'
export default DapDSSearch

DapDSSearch.define()

declare global {
  interface HTMLElementTagNameMap {
    'dap-ds-search': DapDSSearch
  }
}
